import FormContainer from "./FormContainer"
import { Button } from "../../../components/Button"
import { formatNumber } from "../../../app/utils/helpers"
import { forwardRef, useEffect, useRef, useState } from "react"
import { useForm } from "react-hook-form"
import clsx from "clsx"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import { useGlobalContext } from "@/global/GlobalContext"

const OrderSummaryCard = forwardRef(({ btnName, custContainerCls, discountFee = 0, isSubmitForm = false, showFixed = false, isCalculating = true, subTotal, deliveryFee = 0, disabledBtn = false, pageName = "", sendDataToParent = () => { } }, ref) => {
  const { notifyInfo, pathname } = useGlobalContext()
  const { handleSubmit } = useForm()
  const [currPage, setCurrPage] = useState("")
  const defaultErr = {
    "discount_voucher": ""
  }
  const [errors, setErrors] = useState(defaultErr)

  useEffect(() => {
    setCurrPage(pathname.split())
  }, [])

  const calculateTotal = () => {
    return subTotal + deliveryFee - discountFee
  }

  const onSubmit = (formData) => {
    if (!deliveryFee && pageName == "cart") {
      return notifyInfo("Please select a courier!")
    }

    sendDataToParent(formData)
  }

  return (
    <>
      <FormContainer title="Order Summary" custCls={clsx("w-full", custContainerCls)}>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-2">
          {/* TODO: untuk sementara ini hidden dulu yak, nanti aktifkan setelah ada kontrak baru */}
          {/* {pageName == "cart" &&
            <div className="flex gap-4 mb-5">
              <div className="w-3/5">
                <Input type="text" placeholder="Discount Voucher" name="discountVoucher" id="discountVoucher" isCart custCls={errors.name ? "border-red-600 pt-3 pb-2 pl-3" : "pt-3 pb-2 pl-3"} errMsg={errors.name} ref={{ ...register("discount_voucher") }} />
              </div>
              <div className="w-2/5">
                <Button title="Apply" onlyBorder custCls="border-[#dcd6d2] font-normal text-sm sm:text-xl pt-3 pb-2" />
              </div>
            </div>
          } */}
          {/* TODO: nanti aktifkan kalo udah ada kontrak baru */}
          {/* {pageName == "checkout" &&
            <div className="flex justify-between items-end mt-5">
              <span className="text-[#6e605d] font-agcasmlt font-light text-lg sm:text-xl lg:text-2xl">Discount Fee</span>
              {isCalculating ?
                <ContainerSkeleton custH="h-4 sm:h-5" custW="w-32" />
                :
                <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">IDR {formatNumber(discountFee)}</span>
              }
            </div>
          } */}
          <div className="flex justify-between items-end">
            <span className="text-[#6e605d] font-agcasmlt font-light text-lg sm:text-xl lg:text-2xl">Sub Total</span>
            {isCalculating ?
              <ContainerSkeleton custH="h-4 sm:h-5" custW="w-32" />
              :
              <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">IDR {formatNumber(subTotal)}</span>
            }
          </div>
          <div className="flex justify-between items-end mb-5">
            <span className="text-[#6e605d] font-agcasmlt font-light text-lg sm:text-xl lg:text-2xl">Delivery Fee</span>
            {isCalculating ?
              <ContainerSkeleton custH="h-4 sm:h-5" custW="w-32" />
              :
              <span className="text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl">IDR {formatNumber(deliveryFee)}</span>
            }
          </div>
          <div className="border-b-[1.5px] border-[#bc9c5c] w-full"></div>
          <div ref={ref} className="flex justify-between items-end mt-3">
            <span className="text-[#6e605d] font-agcasmlt font-medium text-lg sm:text-xl lg:text-2xl">Total</span>
            {isCalculating ?
              <ContainerSkeleton custH="h-4 sm:h-5 lg:h-6" custW="w-32" />
              :
              <span className="text-[#6e605d] font-medium font-agcasmlt text-lg sm:text-xl  lg:text-2xl">IDR {formatNumber(calculateTotal())}</span>
            }
          </div>
          <div className="w-1/3 mx-auto mt-24">
            <Button type="submit" isSaving={isSubmitForm} disabled={disabledBtn} title={btnName} custCls="text-base lg:text-lg pt-1.5 pb-0.5 font-extralight" />
          </div>
        </form>
      </FormContainer>

      {/* fixed */}
      <div className={clsx("border-t-[1.5px] border-[#bc9c5c] w-full bottom-0 left-0 right-0 z-10 bg-white", { "fixed py-3 px-6 sm:px-10 lg:px-14": showFixed, "hidden": !showFixed })}>
        <div className="flex">
          <span className="hidden sm:flex sm:items-center opacity-80 text-[#6e605d] font-agcasmlt font-medium text-lg sm:text-xl lg:text-2xl w-1/2">Total Payment</span>
          <div className="flex w-full sm:w-1/2 items-end gap-4 justify-end">
            <div className="max-sm:w-1/2 max-sm:flex max-sm:flex-col max-sm:items-end">
              <span className="block sm:hidden opacity-60 text-[#6e605d] font-agcasmlt font-medium text-end text-base w-1/2">Total Payment</span>
              {isCalculating ?
                <ContainerSkeleton custH="h-5 lg:h-8" custW="w-32" />
                :
                <span className="text-[#6e605d] font-medium font-agcasmlt text-[1.2rem] lg:text-[1.875rem] leading-[1.2rem] lg:leading-[1.875rem]">IDR {formatNumber(calculateTotal())}</span>
              }
            </div>
            <div className="">
              <form onSubmit={handleSubmit(onSubmit)} className="mt-2">
                <Button type="submit" isSaving={isSubmitForm} disabled={disabledBtn} title={btnName} custCls="text-base lg:text-lg max-sm:py-2.5 px-4 sm:px-3 pt-1.5 pb-0.5 font-extralight" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
})

export default OrderSummaryCard